<div class="container-md p-md-0">
  <ts-asset-selection
    header="{{ 'my_eligible_lines' | translate }}"
    no_asset_text="{{ 'no_eligible_lines' | translate }}"
    [asset_fields]="['plan', 'add_on_features', 'contract_end_date', 'carrier_account']"
    [existing_asset]="shopping_cart && shopping_cart.existing_asset"
    (asset_selection_emit)="selectAsset($event)"
  />
</div>

<ng-template #confirmLineTerminationModal>
  <ts-confirm-line-termination
    modal_header="{{ 'disconnect_service' | translate }}"
    [asset]="selected_line"
    (confirmChangeCarrier)="skipConfirmation($event)"
  />
</ng-template>

<ng-template #multiSimConfirmation let-modal>
  <div class="modal-header">
    <h4 *ngIf="asset.multi_sim_type === multi_sim_types[0]" class="modal-title">
      {{ 'multisim_device' | translate }}
    </h4>
    <h4
      *ngIf="[multi_sim_types[1], multi_sim_types[6]].includes(asset.multi_sim_type)"
      class="modal-title"
    >
      {{ 'multisim_line' | translate }}
    </h4>
    <button
      class="btn-close"
      type="button"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>
  <div
    *ngIf="asset.multi_sim_type === multi_sim_types[0]"
    class="modal-body pt-0"
    name="1DML-modal-body"
  >
    <div class="row mb-3">
      <div class="col">
        <span class="fw-light" [innerHTML]="multisimModalBody(asset)"></span>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col">
        <span
          *ngIf="asset.multi_sim_type === multi_sim_types[0]"
          class="fw-light"
          [innerHTML]="multisimModalPrompt(asset)"
        >
        </span>
      </div>
    </div>
    <ul class="list-group multisim-lines-modal-list">
      <li
        *ngIf="asset?.device && asset?.line?.status !== 'Inactive'"
        class="d-flex list-group-item list-group-item-action cursor-pointer"
        [ngClass]="{ active: lineInCart(asset.line) }"
        (click)="selectAsset(asset, true)"
      >
        {{ asset.line.international_number }} ({{ asset.line.carrier_name }})
        <span
          class="d-inline-block material-icons fs-inherit ms-1"
          [ngClass]="!lineInCart(asset.line) ? 'text-info' : ''"
        >
          verified
        </span>
      </li>
      <li
        *ngFor="let additional_line of calculateModalAdditionalLines()"
        class="list-group-item list-group-item-action cursor-pointer"
        [ngClass]="{ active: lineInCart(additional_line) }"
        (click)="selectAsset(additional_line, true, true)"
      >
        {{ additional_line.international_number }} ({{ additional_line.carrier_name }})
      </li>
    </ul>
  </div>

  <div
    *ngIf="[multi_sim_types[1], multi_sim_types[6]].includes(asset.multi_sim_type)"
    class="modal-body pt-0"
    name="1LMD-modal-body"
  >
    <div class="row mb-3">
      <div class="col">
        <span class="fw-light" [innerHTML]="multisimModalBody(asset)"> </span>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col">
        <span class="fw-light" [innerHTML]="multisimModalPrompt(asset)"></span>
      </div>
    </div>
    <ul class="list-group">
      <li *ngIf="asset?.device" class="d-flex list-group-item">
        {{ constructAssetTitle(true) }}
        <span class="d-inline-block material-icons fs-inherit text-info ms-1">verified</span>
      </li>
      <li *ngFor="let additional_device of asset.additional_devices!" class="list-group-item">
        {{ constructAdditionalAssetTitle(additional_device, 1) }}
      </li>
    </ul>
    <div class="row mt-3">
      <div class="col d-flex justify-content-end">
        <button type="button" class="btn btn-outline-secondary me-2" (click)="modal.dismiss()">
          {{ 'cancel' | translate }}
        </button>
        <button type="button" class="btn btn-primary" (click)="selectAsset(asset, true)">
          {{ 'continue' | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
